import { motion } from 'framer-motion'

export function LoadingScreen() {
  const containerVariants = {
    hidden: { opacity: 1 },
    visible: { opacity: 0, transition: { duration: 0.5, delay: 1 } }
  }

  const logoVariants = {
    hidden: { scale: 0.3, opacity: 0 },
    visible: { 
      scale: 0.6, 
      opacity: 1,
      transition: { 
        type: 'spring',
        stiffness: 260,
        damping: 20 
      }
    }
  }

  const barVariants = {
    hidden: { width: 0 },
    visible: { 
      width: '100%',
      transition: { 
        duration: 1.5,
        ease: 'easeInOut'
      }
    }
  }

  return (
    <motion.div
      className="fixed inset-0 bg-black z-50 flex items-center justify-center"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="text-center">
        {/* Logo */}
        <motion.div
          className="text-2xl md:text-4xl font-mono mb-4"
          variants={logoVariants}
        >
          <span className="text-[#7ec876]">SYSTEM</span>
          <span className="text-white">_</span>
          <span className="text-[#7ec876]">INIT</span>
        </motion.div>

        {/* Loading Bar */}
        <div className="w-48 h-0.5 bg-gray-800 rounded-full overflow-hidden border border-gray-700">
          <motion.div
            className="h-full bg-gradient-to-r from-cyan-400 to-purple-500"
            variants={barVariants}
            initial="hidden"
            animate="visible"
          />
        </div>

        {/* Loading Text */}
        <motion.p
          className="text-gray-400 mt-3 text-xs font-mono tracking-wider"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { delay: 0.5 } }}
        >
          INITIALIZING ASSETS
        </motion.p>

        {/* Tech details */}
        <motion.div
          className="text-gray-600 mt-2 text-xs font-mono"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { delay: 0.8 } }}
        >
          <div>SYSTEM: ONLINE</div>
          <div>STATUS: BOOTING</div>
        </motion.div>
      </div>
    </motion.div>
  )
}